export default async function hydrator(parameters, d, chart) {

}

// import {
//     nFormatter,
//     createSeries,
//     createSQL,
//     seriesHead,
//     appendAggregateValues,
//     seriesDataItem,
//     pickItem,
//     isDateTransformation,
//     highestModel,
//     averageModel,
//     missingValuesModel,
//     resolve,
//     getSeriesColors,
//     extractColors,
//     createFilter
// } from "@/components/charts/common";
// // import echarts from 'echarts/';
// // import 'echarts/lib/chart/map';

// import * as echarts from 'echarts/dist/echarts.js';

// // const africa = import * as data from '@/components/charts/echart/map/data/africa.json';
// // echarts.registerMap('world',require('echarts/map/json/world.json'));
// echarts.registerMap('africa', require('@/components/charts/echart/map/data/africa.json'));
// echarts.registerMap('europe', require('@/components/charts/echart/map/data/europe.json'));
// echarts.registerMap('usa', require('@/components/charts/echart/map/data/USA.json'));
// echarts.registerMap('gambia', require('@/components/charts/echart/map/data/gambia.json'));
// echarts.registerMap('nigeria', require('@/components/charts/echart/map/data/nigeria.json'));
// echarts.registerMap('gambia-senegal', require('@/components/charts/echart/map/data/gambia-senegal.json'));



// export default async function hydrator(parameters, d, chart) {

//     let chartDataSource = parameters.chartDataSource;
//     let query = {};
//     let fullQuery = chartDataSource.item.fullQuery;
//     let sqlQuery = resolve("sqlQuery.value", parameters);
//     if (sqlQuery) {
//         fullQuery = sqlQuery;
//     }

//     let dynamicOptions = {};

//     dynamicOptions.colors = resolve("colors.value", parameters, "#FFEE58,#FDD835,#FBC02D,#F9A825,#EF5350,#E53935,#D32F2F,#C62828,#B71C1C");

//     var geoCoordMap = {
//         "Amsterdam": [4.895168, 52.370216]
//     };

//     var schema = [
//         "Cities",
//     ];

//     var rawData = [
//         ["Amsterdam", 101.6]
//     ];





//     function makeMapData(rawData) {
//         var mapData = [];
//         for (var i = 0; i < rawData.length; i++) {
//             var geoCoord = geoCoordMap[rawData[i][0]];
//             if (geoCoord) {
//                 let v = geoCoord.concat(rawData[i].slice(1));


//                 mapData.push({ name: rawData[i][0], value: geoCoord.concat(rawData[i].slice(1)) });
//                 console.log("map data", { name: rawData[i][0], value: geoCoord.concat(rawData[i].slice(1)) });
//             }
//         }
//         return mapData;
//     };


//     function _makeMapData(data) {
//         let items = [];
//         for (let i = 0; i < data.length; i++) {
//             let row = data[i];
//             let item = { ...row };
//             item.value = [row.longitude, row.latitude, row.value];
//             items.push(item);
//         }
//         return items;
//     };

//     function makeParallelAxis(schema) {
//         var parallelAxis = [];
//         for (var i = 1; i < schema.length; i++) {
//             parallelAxis.push({ dim: i, name: schema[i] });
//         }
//         return parallelAxis;
//     }


//     function getNameProperty(map) {
//         const names = { africa: 'postal' };
//         // if(typeof names)
//     }
//     // new echarts.graphic.RadialGradient(0.5, 0.5, 0.4, [{
//     //     offset: 0,
//     //     color: '#4b5769'
//     // }, {
//     //     offset: 1,
//     //     color: '#404a59'
//     // }])

//     let effectScatterLayer = {
//         name: 'Highlight',
//         type: 'effectScatter',
//         coordinateSystem: 'geo',
//         show: false,
//         data: [],
//         symbolSize: function (val) {
//             return val[2] / 10;
//         },
//         showEffectOn: 'render',
//         rippleEffect: {
//             brushType: 'stroke'
//         },
//         hoverAnimation: true,
//         label: {
//             formatter: '{b}',
//             position: 'right',
//             show: true
//         },
//         itemStyle: {
//             color: 'purple',
//             shadowBlur: 10,
//             shadowColor: '#333'
//         },
//         zlevel: 1
//     };

//     let scatterLayer = {
//         name: 'Main',
//         type: 'scatter',
//         show: false,
//         coordinateSystem: 'geo',
//         symbolSize: 8,
//         data: [],
//         activeOpacity: 1,
//         label: {
//             formatter: '{b}',
//             position: 'right',
//             show: false
//         },
//         symbolSize: function (val) {
//             return val[2] / 10;
//         },
//         label: {
//             formatter: '{b}',
//             position: 'right',
//             show: false
//         },
//         itemStyle: {
//             color: 'green'
//         },
//         emphasis: {
//             label: {
//                 show: true
//             }
//         }
//     };


//     let mapLayer = {

//         name: 'Main Map',
//         type: 'map',
//         show: false,
//         roam: true,
//         nameProperty: 'name_sort',
//         //  map: 'africa',
//         coordinateSystem: 'geo',
//         emphasis: {
//             label: {
//                 show: false,
//                 areaColor: '#000'
//             }
//         },
//         itemStyle: {
//             areaColor: '#3B4C6F',
//             borderWidth: 0.2,
//             borderColor: '#818EB7'
//         },
//         emphasis: {
//             label: {
//                 show: true
//             }
//         },
//         data: [],
//         left: '6%',
//         top: 40,
//         bottom: '10%',
//         right: '14%',
//         nameMap: {
//             'Gambia': 'Gambia, The',
//             'W. Sahara': 'Western Sahara',
//             'Egypt': 'Egypt, Arab Rep.',
//             'Central African Rep.': 'Central African Republic',
//             'S. Sudan': 'South Sudan',
//             'Cote d\'Ivoire': 'Cote d\'Ivoire',
//             'Eq. Guinea': 'Equatorial Guinea',
//             'Dem. Rep. Congo': 'Congo, Dem. Rep.',
//             'Congo': 'Congo, Rep.'
//         }
//     };







//     let showProperties = { map: true, scatter: false, effectScatter: false };

//     function createNameMap(name) {
//         let m = echarts.getMap('africa');
//         console.log("countries m", m);
//         // for(let i = 0; i < m.name )
//     }


//     let options = {
//         backgroundColor: 'transparent',
//         title: {
//             text: '',
//             subtext: '',
//             sublink: '',
//             left: 'center',
//             top: 5,
//             itemGap: 0,
//             textStyle: {
//                 color: '#eee'
//             },
//             z: 200
//         },
//         tooltip: {
//             trigger: 'item',
//             formatter: function (params) {
//                 //var value = (params.value + '').split('.');
//                 //value = value[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + '.' + value[1];
//                 if (Array.isArray(params.value)) {
//                     return params.seriesName + '<br/>' + params.name + ' : ' + params.value[2];
//                 }
//                 return params.seriesName + '<br/>' + params.name + ' : ' + params.value;
//             }
//         },
//         toolbox: {
//             show: false,
//             left: 'right',
//             iconStyle: {
//                 normal: {
//                     borderColor: '#ddd'
//                 }
//             },
//             feature: {
//             },
//             z: 202
//         },
//         brush: {
//             geoIndex: 10,
//             brushLink: 'all',
//             inBrush: {
//                 opacity: 1,
//                 symbolSize: 14
//             },
//             outOfBrush: {
//                 color: '#000',
//                 opacity: 0.2
//             },
//             z: 10
//         },
//         visualMap: {
//             left: '15%',
//             top: '50%',
//             min: 0,
//             max: 0,
//             splitNumber: 5,
//             color: ['#d94e5d', '#eac736'],
//             // inRange: {
//             //   color: (function () {
//             //     var colors = dynamicOptions.colors.split(",");
//             //     return colors.concat(colors);
//             //   })()
//             // },
//             // text: ['High', 'Low'],
//             // calculable: true
//         },
//         geo: {
//             map: 'world',
//             show: true,
//             silent: true,
//             roam: false,
//             nameProperty: 'name_sort',
//             emphasis: {
//                 label: {
//                     show: false,
//                     areaColor: '#000'
//                 }
//             },
//             itemStyle: {
//                 areaColor: '#3B4C6F',
//                 borderWidth: 0.2,
//                 borderColor: '#818EB7'
//             },
//             left: '6%',
//             top: 40,
//             bottom: '10%',
//             right: '14%'
//         },
//         grid: [
//             //   {
//             //     show: true,
//             //     left: 0,
//             //     right: 0,
//             //     top: '90%',
//             //     bottom: 0,
//             //     borderColor: 'transparent',
//             //     backgroundColor: 'transparent',
//             //     z: 99
//             // }, {
//             //     show: true,
//             //     left: 0,
//             //     right: 0,
//             //     top: 0,
//             //     height: 28,
//             //     borderColor: 'transparent',
//             //     backgroundColor: 'transparent',
//             //     z: 199
//             // }
//         ],
//         series: []
//     };



//     //

//     // #FFEE58,#FDD835,#FBC02D,#F9A825,#EF5350,#E53935,#D32F2F,#C62828,#B71C1C


//     query.id = chartDataSource.item.id;

//     let _filters = resolve("tree.filters", chart);
//     //  console.log(_filters);
//     let filters = _filters ? Object.values(_filters) : [];

//     let sqlFilter = createFilter(chart, parameters);

//     let sql = "SELECT * FROM (" + fullQuery + ") AS _subQuery ";
//     sql += "WHERE 1 = 1 ";
//     if (sqlFilter) {
//         sql = sql + " AND " + sqlFilter;
//     }




//     query.sql = sql;
//     let dd = await chartDataSource.item.request(query);

//     // console.log("query", query);
//     //let dd = await chartDataSource.item.request(query);
//     chart.response = dd;





//     if (dd.data.length > 5000) {
//         return false;
//     }


//     console.log("data", dd.data);
//     let data = dd.data;

//     let mapData = _makeMapData(data);

//     let mx = Math.max(...data.map(function (o) { return isNaN(o.value) || !o.value ? 0 : parseFloat(o.value); }));
//     let mn = Math.min(...data.map(function (o) { return isNaN(o.value) || !o.value ? 0 : parseFloat(o.value); }));

//     console.log(data.map(function (o) { return o.value; }));

//     mx = mx > 0 ? Math.ceil(mx / 10) * 10 : mx;


//     console.log("max", mx);
//     let symbolSize = function (v) {
//         let max = mx;
//         //return 3;
//         return 5 + ((v[2] * 15) / max);
//     }

//     options.visualMap.max = mx;
//     options.visualMap.min = mn;

//     options.title.text = resolve("title.value", parameters, '');
//     options.title.subtext = resolve("subTitle.value", parameters, '');
//     options.title.textStyle.color = resolve("titleColor.value", parameters, '#000');

//     options.geo.map = resolve("mapTypeData.value", parameters, 'world');

//     let nameMap = createNameMap(options.geo.map, data);

//     if (showProperties.map && !showProperties.scatter && !showProperties.effectScatter) {
//         options.geo.show = false;
//         mapLayer.map = options.geo.map;
//         mapLayer.data = data;
//         mapLayer.itemStyle.areaColor = resolve("tileBackgroundColor.value", parameters, '#3B4C6F');
//         mapLayer.itemStyle.borderColor = resolve("tileBorderColor.value", parameters, '#818EB7');
//         options.series.push(mapLayer);
//     }

//     //options.geo.data = data;

//     // options.geo.itemStyle.areaColor = resolve("tileBackgroundColor.value", parameters, '#3B4C6F');
//     // options.geo.itemStyle.borderColor = resolve("tileBorderColor.value", parameters, '#818EB7');
//     //
//     // options.series[0].map = resolve("mapTypeData.value", parameters, 'world');
//     // options.series[0].data = data;
//     //
//     // options.series[1].data = mapData;
//     // options.series[1].symbolSize = symbolSize;
//     // options.series[1].itemStyle.color = resolve("mainBackgroundColor.value", parameters, 'purple');
//     // // options.series[0].itemStyle.shadowColor = resolve("mainShadowColor.value", parameters, options.series[0].itemStyle.color);
//     //
//     //
//     // options.series[2].data = mapData.filter(function(v) { return v.highlight == 1});
//     // options.series[2].symbolSize = symbolSize;
//     //
//     // options.series[2].itemStyle.color = resolve("highlightBackgroundColor.value", parameters, 'purple');
//     // options.series[2].itemStyle.shadowColor = resolve("highlightShadowColor.value", parameters, options.series[1].itemStyle.color);




//     // console.log("data", options.series[1].data)

//     chart.options = options;

//     chart.draw = () => {
//         console.log("refs draw");
//         if (typeof chart.refs != "undefined") {

//             if (typeof chart.uiLoaded == "undefined") {
//                 chart.uiLoaded = false;
//             }
//             console.log("refs", chart.refs.echart);
//             // chart.refs.echart.mergeOptions(chart.options);
    
    
//             if (typeof chart.thisEChart == "undefined" || chart.uiLoaded) {
//                 chart.thisEChart = echarts.init(chart.refs.echart);
//                 chart.uiLoaded = true;
//                 console.log("draw again");
//                 // chart.thisElement.setOption(chart.options);
//             } else {
//                 chart.thisEChart = echarts.init(chart.refs.echart);
//                 console.log("dont't redraw");
//                 // chart.thisElement.mergeOptions(chart.options);
//             }
    
//             // console.log("draw again");
//             chart.thisEChart.setOption(chart.options, true);
    
//             //console.log("map", echarts.getMap('africa'));
    
    
//             // if(typeof chart.refs.echart.options == "undefined") {
//             //   chart.refs.echart.options = chart.options;
//             //   chart.refs.echart.mergeOptions(chart.options);
//             // } else {
//             //   chart.refs.echart.mergeOptions(chart.options);
//             // }
//             //  console.log("chart.refs", chart.refs);
//         } else {
//             console.log("refs is undefined");
//         }
//     };

//     chart.render = true;
//   if (typeof chart.refs != "undefined") {
//     chart.draw();
//   }
    
// }
